'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _InputNameEditor = require('./InputNameEditor.css');

var _InputNameEditor2 = _interopRequireDefault(_InputNameEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputNameEditor = function (_Component) {
  (0, _inherits3.default)(InputNameEditor, _Component);

  function InputNameEditor(props) {
    (0, _classCallCheck3.default)(this, InputNameEditor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InputNameEditor.__proto__ || (0, _getPrototypeOf2.default)(InputNameEditor)).call(this, props));

    _this.updateInputName = _this.updateInputName.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InputNameEditor, [{
    key: 'updateInputName',
    value: function updateInputName(e) {
      var _props = this.props,
          id = _props.id,
          updateInputName = _props.updateInputName;

      updateInputName(id, e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var name = this.props.name;

      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(_components.EnterpriseInput, {
          type: 'text',
          onChange: this.updateInputName,
          value: name,
          placeholder: 'NAME',
          className: _InputNameEditor2.default.mono
        })
      );
    }
  }]);
  return InputNameEditor;
}(_react.Component);

exports.default = InputNameEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InputNameEditor/InputNameEditor.jsx
// module id = 1455
// module chunks = 0